<template>

    <div class="page-center content-load animated fadeIn">

        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-xl-6 col-xl-offset-3 col-md-6 col-md-offset-3">

                    <div class="login-register-page">

                        <center>
                            <img src="static/images/logo.png" width="180" class="logo margin-bottom-20">
                        </center>                        
                        
                    </div>

                </div>
            </div>
        </div>  
    </div>
</template>

<script>
export default {
    name:                           'Inicio',
    data () {
        var self                    = this;
        return {
            termos:                 true,
            loading: {
                "submit":           false,
            },
            form: {
            }
        }
    },
    methods: {

    },
    mounted: function() {
        setTimeout(function() {
            loading.hide();
        }, 1000);
    } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
    .page-inicio #wrapper {
        background: #fe0100 !important;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }   
      
</style>



// WEBPACK FOOTER //
// src/components/Inicio.vue